import { GetPageTitle } from "@/actions/search/services/AdSearchTitleService";
import { ParseUrl } from "@/actions/search/services/AdSearchUrlService";
import { PRIMARY_COLOR } from "@/app/layout/LayoutConstants";
import { useUserSaveType } from "@/app/layout/useUserSaves";
import {
  Box,
  CircularProgress,
  IconButton,
  MenuItem,
  styled,
  Switch,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import Link from "next/link";

function GetSearchTitleFromPath(searchPath: string): string {
  const slugs = searchPath.split("/").filter((s) => s.length > 0);
  const searchRequest = ParseUrl(slugs);
  const searchTitle = GetPageTitle(searchRequest);
  return searchTitle;
}

const EmailSubscriptionSwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb": {
        backgroundColor: PRIMARY_COLOR,
        "&:before": {
          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
            "#fff",
          )}" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 4-8 5-8-5V6l8 5 8-5z"/></svg>')`,
        },
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.grey[300],
    width: 32,
    height: 32,
    "&::before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        "#black",
      )}" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 14H4V8l8 5 8-5zm-8-7L4 6h16z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.grey[100],
    borderRadius: 20 / 2,
  },
}));

function BlockClickEvent(event: React.MouseEvent) {
  event.stopPropagation();
  event.preventDefault();
  event.nativeEvent.stopImmediatePropagation();
}

export function SavedSearchesList({ searchPath }: { searchPath?: string }) {
  const { userSaves, status, RemoveUserSave, ToggleSubscribed } =
    useUserSaveType("SEARCH");
  return (
    <>
      {status !== "ready" ? (
        <CircularProgress />
      ) : (
        <>
          {userSaves.length === 0 ? (
            <Typography>You don&apos;t have any saved searches.</Typography>
          ) : (
            <>
              {userSaves.map((save) => (
                <MenuItem
                  key={save.key}
                  component={Link}
                  href={`/for-sale/${save.key}`}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight:
                        searchPath && searchPath === save.key
                          ? "bold"
                          : "normal",
                      whiteSpace: "normal",
                    }}
                  >
                    {GetSearchTitleFromPath(save.key)}
                  </Typography>
                  <Box
                    sx={{
                      marginLeft: "auto",
                    }}
                  >
                    <EmailSubscriptionSwitch
                      onClick={async (e) => {
                        BlockClickEvent(e);
                        await ToggleSubscribed(save.key);
                      }}
                      checked={!save.isUnsubscribed}
                    />
                  </Box>
                  <IconButton
                    onClick={async (e) => {
                      BlockClickEvent(e);
                      await RemoveUserSave(save.key);
                    }}
                    sx={{
                      margin: -1,
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                </MenuItem>
              ))}
            </>
          )}
        </>
      )}
    </>
  );
}
